import axios from "axios";

export default {
    getLastTimeEntry: async() => {
        const { data } =  await axios.get("/time_entries/last_time_entry/")
        let lastTimeEntry = null

        for (let i in data) {
            lastTimeEntry = data[i]
        }

       return lastTimeEntry
    },
    getCurrentPersonTimeEntries: async(taskId, limit) => {
        const { data } = await axios.get('/time_entries/', { params: { task_id: taskId, all_users: 0, limit: limit }})

        return data
    },
    getAllTimeEntries: async (taskId, limit) => {
        const { data } = await axios.get('/time_entries/', { params: { task_id: taskId, all_users: 1, limit: limit }})

        return data
    },
    saveTimeEntry: async(payload) => {
        const id = payload.id ? payload.id : ''

        const { data } =  await axios.post(`/time_entries/${id}`, payload)

        return data
    },
    saveTimeEntryOverlapNext: async(data) => {
        const id = data.id ? data.id : ''

        return await axios.post(`/time_entries/overlap_next/${id}`, data)
    },
    deleteTimeEntry: async(timeEntryId) => {
        await axios.delete("time_entries/{0}".format(timeEntryId))
    },
    saveExistingTimeEntryDescription: async(id, description) => {
        const { data } = await axios.post(`/time_entries/${id}/description`, {
            description
        })

        return data
    },
    completeTask: async(virtual_id, completeType = '', billable = 1) => {
        const { data } = await axios.post(`/timer/complete`, null, {
            params: {
                task_id: virtual_id,
                complete_type: completeType,
                billable: billable
            }
        })

        return data
    },
    fetchCalendarTotals: async (payload) => {
        const { data } = await axios.get(`/time_entries/totals`, {
            params: {
                date_from: payload.date_from,
                date_until: payload.date_until,
                flextime_company_id: payload.flextime_company_id,
                flextime_country_code: payload.flextime_country_code,
                company_ids: payload.company_ids,
            }
        })
        return data
    }
}
